import axiosInstance from '../utils/axiosInstance';

export async function getAllPayrollRuns() {
    const { data } = await axiosInstance.get('/payroll');
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function getandCreatePayrollData(body) {
    const { data } = await axiosInstance.post('/payroll/payroll-data', body);
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function getLatestPayrollRun() {
    const { data } = await axiosInstance.get('/payroll/latest');
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function lockPayrollRun(payroll_run_id, employees) {
    const { data } = await axiosInstance.patch('/payroll/lock', { payroll_run_id, employees });
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function savePayrollDraft(payroll_run_id, employees) {
    const { data } = await axiosInstance.patch('/payroll/save-draft', { payroll_run_id, employees });
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function getPayableReimbursements(employee_id, month, year, allApproved = false) {
    const { data } = await axiosInstance.get('/payroll/payable-reimbursements', { params: { employee_id, month, year, all: allApproved ? 1 : undefined } });
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function completePayRun(payroll_run_id) {
    const { data } = await axiosInstance.patch('/payroll/complete', { payroll_run_id });
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function getPayrollByMonthAndYear(selectedMonth, selectedYear) {
    const { data } = await axiosInstance.get('/payroll/month/year', { params: { month: selectedMonth, year: selectedYear } });
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function emailPayslipsWithPdfs(formData) {
    const { data } = await axiosInstance.post('/payroll/payslips/email-with-pdfs', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function getPayslipEmailJob(jobId) {
    const { data } = await axiosInstance.get(`/payroll/payslips/email-jobs/${jobId}`);
    return Array.isArray(data) ? data : data?.data ?? [];
}

export const getEmployeePayslips = async ({
    employeeId,
    page = 1,
    limit = 6,
    search = "",
    year = "",
    type = "",
}) => {
    const { data } = await axiosInstance.get("/payroll/employee/payslips", {
        params: {
            employeeId,
            page,
            limit,
            search: search || undefined,
            year: year !== "all" ? year : undefined,
            type: type !== "all" ? type : undefined,
        },
    });
    return Array.isArray(data) ? data : data?.data ?? [];
};

export async function deletePayrollRun(payroll_run_id) {
    const { data } = await axiosInstance.delete('/payroll', { params: { payroll_run_id } });
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function getTerminationPayroll(payload) {
    const { data } = await axiosInstance.post('/payroll/termination', payload);
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function getPayrollRunById(payrollRunId) {
    const { data } = await axiosInstance.get(`/payroll/${payrollRunId}`);
    return data?.data;
}

export async function getPayrollRunsByType(type) {
    const { data } = await axiosInstance.get(`/payroll/type/${type}`);
    return data?.data;
}

export async function getOneTimePayrollRuns() {
    const { data } = await axiosInstance.get(`/payroll/one-time`);
    return data?.data;
};

export async function createOneTimePayroll(payload) {
    const { data } = await axiosInstance.post("/payroll/one-time", payload);
    return data?.data;
}
